export default __webpack_public_path__ + "static/media/timeline-control.f8bdab4d.svg";